<template>
  <div class="header">
    <div class="header-inner">
      <div class="header-left">
        <span class="logo" v-if="$route.path!=='/'" @click.stop="$router.push('/')"></span>
        <span class="logo" v-else style="cursor: default;"></span>
        <span class="divider"></span>
        <el-dropdown trigger="click" @command="switchPlatform" placement="bottom-start" v-if="showSwitch">
          <span class="platform-name" style="cursor: pointer;">物联平台<i class="el-icon-caret-bottom"></i></span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="develop">开发者平台</el-dropdown-item>
            <el-dropdown-item command="service">服务商平台</el-dropdown-item>
            <el-dropdown-item command="yiyun">管理后台</el-dropdown-item>
            <el-dropdown-item command="doc">文档中心</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <span class="platform-name" v-else>物联平台</span>
        <slot>
          <div :class="['menu-item',{active: route.startsWith(item.routePath)}]" v-for="(item, index) in headMenu" :key="index" @click.stop="$router.push(item.routePath)">
            <div class="menu-label">{{item.label}}</div>
            <div class="menu-bottom"></div>
          </div>
        </slot>
      </div>
      <div style="margin-right: 15px;height: 40px; display: flex;align-items: flex-end;">
        <slot name="right"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Header',
  props: {
    headMenu: {
      type: Array,
      default: () => []
    },
    showSwitch: Boolean
  },
  data () {
    return {}
  },
  computed: {
    route () {
      return this.$route.path
    }
  },
  methods: {
    switchPlatform (command) {
      let url
      switch (command) {
        case 'develop':
          window.open(process.env.VUE_APP_DEVELOPER_HOST + 'main')
          break
        case 'service':
          window.open(process.env.VUE_APP_SERVICE_PROVIDER_HOST + 'main')
          break
        case 'yiyun':
          window.open(process.env.VUE_APP_SITE_HOST + '/pc/platform/index.html#/')
          break
        case 'doc':
          url = 'https://help.ptest.effio.cn'
          switch (process.env.VUE_APP_MODE) {
            case 'production':
              url = 'https://help.effio.cn/'
              break
            case 'staging':
              url = 'https://staging-help.effio.cn/'
              break
            default:
              break
          }
          window.open(url)
          break
        default:
          break
      }
    }
  }
}
</script>

<style scoped lang="less">
  .header {
    width: 100%;
    height: 70px;
    background-color: #223361;
    display: flex;
    justify-content: center;
    z-index: 10;
    overflow-x: auto;
    overflow-y: hidden;
  }
  .header-inner {
    width: 100%;
    height: 70px;
    display: flex;
    min-width: 450px;
    align-items: center;
    justify-content: space-between;
    flex-shrink: 0;
    position: relative;
    color: #fff;
    .header-left{
      display: flex;
      align-items: flex-end;
      height: 40px;
      margin-left: 15px;
    }
    .divider{
      display: inline-block;
      width: 1px;
      height: 20px;
      background-color: rgba(255,255,255,0.3);
      margin-left: 17px;
    }
    .logo{
      display: inline-block;
      width: 101px;
      height: 34px;
      cursor: pointer;
      background: url(../assets/images/head_white_logo.png) center no-repeat;
      background-size: 100%;
    }
    .platform-name{
      font-size: 18px;
      margin-left: 17px;
      font-weight: 600;
      width: 120px;
      margin-right: 117px;
      color: #fff;
    }
    .menu-item{
      font-size: 16px;
      font-weight: 500;
      color: rgba(255,255,255,0.65);
      position: relative;
      height: 100%;
      display: flex;
      align-items: flex-end;
      justify-content: center;
      cursor: pointer;
      +.menu-item{
        margin-left: 42px;
      }
      .menu-bottom{
        width: calc(100% - 8px);
        display: flex;
        height: 4px;
        background-color: transparent;
        position: absolute;
        bottom: -5px;
      }
      &.active{
        color: #fff;
        .menu-bottom{
          background-color: #fff;
        }
      }
    }
  }
</style>
